/* eslint-disable no-nested-ternary */
import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { isMobile } from 'app-constants';

const useStyles = makeStyles((theme) => createStyles({
    availability: {
      display: 'flex',
      position: 'absolute',
      padding: 5,
      borderRadius: 4,
      background: theme.palette.background.default,
      color: '#cbcbcb',
      top: 8,
      transform: 'translateX(-50%)',
      width: (isListView) => (!isListView && isMobile ? '50%' : '26%'),
      alignItems: 'center',
      justifyContent: 'space-evenly',
      marginLeft: 57
    },

    availabilityRu: {
      display: 'flex',
      position: 'absolute',
      padding: 5,
      borderRadius: 4,
      background: theme.palette.background.default,
      color: '#cbcbcb',
      top: 8,
      transform: 'translateX(-50%)',
      width: (isListView) => (!isListView && isMobile ? '80%' : '42%'),
      alignItems: 'center',
      justifyContent: 'space-evenly',
      marginLeft: 87
    }
  }));

function Availability({ available, booked }) {
  const { t, i18n } = useTranslation();
  const isListView = useSelector((state) => state.userPrefference.isListView);
  const classes = useStyles(isListView, i18n.language === 'ru');

  return (
    <div className={i18n.language === 'ru' ? classes.availabilityRu : classes.availability}>
      {available ? (
        <>
          <Icon style={{ color: !booked ? 'green' : '#2196f3' }}>{booked ? 'info' : 'check_circle'}</Icon>
          <Typography style={{ marginLeft: 5, marginRight: 5 }} variant="body2" color="textSecondary">
            {booked ? t('product-reserved') : t('product-available')}
          </Typography>
        </>
      ) : (
        <>
          <Icon color="error">cancel</Icon>
          <Typography style={{ marginLeft: 5, marginRight: 5 }} variant="body2" color="textSecondary">
            {t('product-sold')}
          </Typography>
        </>
      )}
    </div>
  );
}

export default Availability;
